// redux/authApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: 'https://api.utkarsita.com/api/v1',
  credentials: 'include', 
  prepareHeaders: (headers) => {
    headers.set('Content-Type', 'application/json');
    return headers;
  },
});

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery,
  endpoints: (builder) => ({
    sendOtp: builder.mutation({
      query: (phoneNumber) => ({
        url: "/sendOtp",
        method: "POST",
        body: { phoneNumber },
      }),
    }),
    verifyOtp: builder.mutation({
      query: ({ phoneNumber, otp }) => ({
        url: "/verifyOTP-login-signup",
        method: "POST",
        body: { phoneNumber, otp },
      }),
    }),
    loginUser: builder.mutation({
      query: (data) => ({
        url: "/login",
        method: "POST",
        body: data,
      }),
    }),
    signUpAuth: builder.mutation({
      query: ({ data }) => ({
        url: "/signup",
        method: "POST",
        body: data,
      }),
    }),

    logoutUser: builder.mutation({
      query: (data) => ({
        url: "/logout",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useSendOtpMutation,
  useVerifyOtpMutation,
  useLoginUserMutation,
  useSignUpAuthMutation,
  useLogoutUserMutation,
} = authApi;
